import { useMemo } from 'react'
import { collection, limit, orderBy, query } from 'firebase/firestore'
import { useCollectionData } from 'react-firebase-hooks/firestore'
import { firebase_firestore } from '../../../../common/firebaseConfig'
import { CompositeDef } from '../../../../types/composite'

export interface IndicatorVersion {
  version: number
  created: number
  def: CompositeDef
}

/** The immutable version history of a custom indicator, newest first. */
export default function useIndicatorVersions(indicatorId: string | null) {
  const [docs, loading, error] = useCollectionData(
    indicatorId
      ? query(
          collection(firebase_firestore, `customIndicators/${indicatorId}/versions`),
          orderBy('version', 'desc'),
          // Versions are immutable and accrue on every publish — only recent
          // ones are ever shown/loaded, so bound the listener
          limit(50)
        )
      : null
  )

  const versions = useMemo(() => {
    const parsed: IndicatorVersion[] = []
    for (const raw of (docs ?? []) as any[]) {
      if (typeof raw?.defJson !== 'string' || typeof raw?.version !== 'number') continue
      try {
        const def = JSON.parse(raw.defJson)
        if (def?.v === 1) parsed.push({ version: raw.version, created: raw.created ?? 0, def })
      } catch {
        // Skip malformed version docs
      }
    }
    return parsed
  }, [docs])

  return { versions, loading, error }
}
